import initAxios from "./initAxios";

class FirmApi {
  constructor(apiUrl) {
    this.apiUrl = apiUrl;
    this.axios = initAxios({ baseURL: apiUrl, withCredentials: true });
  }

  getFirmSearchResults = (searchString) =>
    this.axios.post("/webapi/extendedsearch/v2/firms/", searchString);

  getFirmIcons = (ids) =>
    this.axios.post("/webapi/icons/v1/?iconTypes=1", JSON.stringify(ids));
}

export default FirmApi;
